import React, { useState, useEffect } from 'react';
import {menuData} from "../../data/menuData";
// @ts-ignore
const title = menuData[7].children[1].title;
const description = `When an accountant finds debits and credits unequal,
 requiring a manual journal entry, it signals an error in the double-entry 
 system, where all transactions must balance. This imbalance, often 
 from single-sided entries or amount mistakes, necessitates a meticulous
  investigation to identify the specific error. The solution involves 
  creating a new, separate manual journal entry with corresponding 
  debits and credits to correct the original mistake, thereby restoring
   balance and integrity to the financial records.`;

const chartOfAccounts_images = [
    '/images/accountant/manual-journal/journal-overview.png', // 0
    '/images/accountant/manual-journal/journal-search.png', // 1
    '/images/accountant/manual-journal/journal-search-box.png', // 2
    '/images/accountant/manual-journal/new-button.png', // 3
    '/images/accountant/manual-journal/new-journal.png', // 4
];

const topic = [
    {
        title: 'Home',
        description: ``,
        id: 'home',
    },
    {
        title: 'Search',
        description: `.`,
        id: 'search',
    },
    {
        title: 'New Journal',
        description: ``,
        id: 'new-journal',
    },
];

const ManualJournal: React.FC = () => {
    const [activeId, setActiveId] = useState(topic[0].id);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const newActiveId = entry.target.id;
                        setActiveId(newActiveId);
                        window.history.replaceState(null, '', `#${newActiveId}`);
                    }
                });
            },
            {
                root: null,
                rootMargin: '-50% 0% -50% 0%',
                threshold: 0,
            }
        );

        topic.forEach((item) => {
            const section = document.getElementById(item.id);
            if (section) {
                observer.observe(section);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    const handleItemClick = (id: string) => {
        setActiveId(id);
    };

    return (
        <div className="max-w-4xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">
                {/* Chart of Accounts */}
                <div className="mb-6"   id={topic[0].id}>
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <img
                            src={chartOfAccounts_images[0]}
                            alt={title}
                            className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                    </div>
                </div>

                {/* Search */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6"  id={topic[1].id}>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Search</h2>
                    <p className="text-gray-600 mb-4">
                        Modern accounting software facilitates efficient management of manual
                        journal entries by providing dedicated sections with advanced search
                        and filter functions, allowing accountants to quickly locate specific
                        transactions using various criteria like date, journal number, or description.
                    </p>
                    <img
                        src={chartOfAccounts_images[1]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                    <p className="text-gray-600 pt-4 mb-4">
                        Clicking the "search" or "filter" button within the manual journals
                        section opens a search box, enabling users to input criteria to quickly
                        find specific entries among all recorded manual journals.
                    </p>
                    <img
                        src={chartOfAccounts_images[2]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                </div>

                {/* New */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6"  id={topic[2].id}>
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">New Journal</h2>
                    <p className="text-gray-600 mb-4">
                        To make a new journal entry, just click the "New Journal" button.
                    </p>
                    <img
                        src={chartOfAccounts_images[3]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                    <p className="text-gray-600 pt-4 mb-4">
                        Clicking the "New Journal" button opens a dedicated box or form where you can input all the details for your new journal entry.
                    </p>
                    <img
                        src={chartOfAccounts_images[4]}
                        alt={title}
                        className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>

                </div>
            </div>

            {/* side route */}
            <div className="fixed w-1/5 right-2">
                <ul>
                    {topic.map((item) => (
                        <li key={item.id} className="mb-4">
                              <span className="text-xs">
                                    <a
                                        className={`hover:text-blue-700 border-l p-4 ${
                                            activeId === item.id ? 'text-blue-700 font-bold border-blue-700' : ''
                                        }`}
                                        href={`#${item.id}`}
                                        onClick={() => handleItemClick(item.id)}
                                    >
                                      {item.title}
                                    </a>
                              </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ManualJournal;
